import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/bn';

export default function BN() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
